import { combineReducers } from 'redux';
import flashMessages from './flashMessages';
import auth from './auth';
import contactInfo from './contactInfo';

export default combineReducers({
    flashMessages,
    contactInfo,
    auth
});